<script lang="ts">
	import ActivityLog from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/ActivityLog.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';
	import type { Device } from 'src/types/Device';
	import { Container } from '@Shelly/shelly-design-system/index';

	export let device: Device;
	export let openedEventTimestamp: number | null = null;
</script>

<Container padding="0" class="pl-m pr-m pb-s">
	<CameraCloudStoragePromoBanner deviceId={device?.id} />
</Container>
<ActivityLog {device} {openedEventTimestamp} />
